import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Landing.css';

// Phone mockup lists - hero card style (3 lists only)
const PHONE_LISTS = [
  {
    id: 1,
    title: 'US National Parks',
    location: 'United States',
    category: 'Parks/Outdoors',
    placeCount: 63,
    imageUrl: 'https://images.unsplash.com/photo-1472396961693-142e6e269027?w=600&q=80'
  },
  {
    id: 2,
    title: '2025 James Beard Award Nominees',
    location: 'Global',
    category: 'Food & Drinks',
    placeCount: 484,
    imageUrl: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600&q=80'
  },
  {
    id: 3,
    title: 'Tokyo 2026',
    location: 'Tokyo, Japan',
    category: 'Travel',
    placeCount: 47,
    imageUrl: 'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=600&q=80'
  }
];

// Discover section lists - different from phone mockup
const DISCOVER_LISTS = [
  {
    id: 1,
    title: 'Best Coffee Shops in NYC',
    location: 'New York, NY',
    category: 'Coffee & Tea',
    placeCount: 34,
    visitedPercent: 45,
    followers: 128,
    isPublic: true,
    imageUrl: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=600&q=80'
  },
  {
    id: 2,
    title: 'Paris Hidden Gems',
    location: 'Paris, France',
    category: 'Restaurants',
    placeCount: 52,
    visitedPercent: 23,
    followers: 341,
    isPublic: true,
    imageUrl: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=600&q=80'
  },
  {
    id: 3,
    title: 'LA Rooftop Bars',
    location: 'Los Angeles, CA',
    category: 'Bars & Nightlife',
    placeCount: 28,
    visitedPercent: 67,
    followers: 89,
    isPublic: true,
    imageUrl: 'https://images.unsplash.com/photo-1470337458703-46ad1756a187?w=600&q=80'
  },
  {
    id: 4,
    title: 'London Art Galleries',
    location: 'London, UK',
    category: 'Museums & Art',
    placeCount: 41,
    visitedPercent: 12,
    followers: 256,
    isPublic: true,
    imageUrl: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=600&q=80'
  },
  {
    id: 5,
    title: 'SF Date Night Spots',
    location: 'San Francisco, CA',
    category: 'Restaurants',
    placeCount: 38,
    visitedPercent: 55,
    followers: 412,
    isPublic: true,
    imageUrl: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=600&q=80'
  },
  {
    id: 6,
    title: 'Austin Food Trucks',
    location: 'Austin, TX',
    category: 'Food & Drinks',
    placeCount: 67,
    visitedPercent: 34,
    followers: 178,
    isPublic: true,
    imageUrl: 'https://images.unsplash.com/photo-1565123409695-7b5ef63a2efb?w=600&q=80'
  }
];

const SAMPLE_PLACES = [
  {
    id: 1,
    name: 'Yosemite National Park',
    category: 'National Park',
    address: 'Yosemite Valley, California',
    status: 'visited',
    isOpen: null, // National parks don't have open/closed status
    friendsSaved: 3,
    imageUrl: 'https://images.unsplash.com/photo-1472396961693-142e6e269027?w=400&q=80'
  },
  {
    id: 2,
    name: 'The Met',
    category: 'Museum',
    address: '1000 5th Ave, New York',
    status: 'want-to-go',
    isOpen: true,
    friendsSaved: 7,
    imageUrl: 'https://images.unsplash.com/photo-1564399579883-451a5d44ec08?w=400&q=80'
  },
  {
    id: 3,
    name: 'Aman Tokyo',
    category: 'Hotel',
    address: 'Otemachi Tower, Tokyo',
    status: 'highly-recommended',
    isOpen: null,
    friendsSaved: 2,
    imageUrl: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400&q=80'
  },
  {
    id: 4,
    name: 'Blue Bottle Coffee',
    category: 'Coffee & Tea',
    address: '315 Linden St, San Francisco',
    status: 'gem',
    isOpen: false,
    friendsSaved: 5,
    imageUrl: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=400&q=80'
  }
];

const FEATURES = [
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
      </svg>
    ),
    title: 'Curate Your Lists',
    description: 'Create personalized lists of places — restaurants, shops, museums, and more. Organize by city, category, or occasion.'
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
    ),
    title: 'Find New Places',
    description: 'Discover recommendations from people you trust. Connect with friends and follow creators to see their latest favorite spots.'
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    ),
    title: 'Track Your Visits',
    description: 'Mark places as visited, want-to-go, highly recommended, or gems. Never forget that amazing spot again.'
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
    title: 'Plan Your Trips',
    description: 'Turn any list into a day-by-day itinerary. Drag and drop places into your schedule and get directions to each destination.'
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    ),
    title: 'Explore on the Map',
    description: 'See all your saved places on an interactive map. Filter by what\'s open now or when you\'ll be there.'
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    title: 'Share with Friends',
    description: 'Collaborate on lists with friends and share your discoveries. Explore your city together or prepare for your next adventure.'
  }
];

function ListPreviewCard({ list }) {
  return (
    <div className="landing-list-card">
      <div className="landing-list-card-hero">
        <img src={list.imageUrl} alt={list.title} className="landing-list-hero-photo" />
        <div className="landing-list-hero-overlay" />
        {list.isPublic && (
          <div className="landing-list-public-badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <circle cx="12" cy="12" r="10" />
              <line x1="2" y1="12" x2="22" y2="12" />
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
            </svg>
          </div>
        )}
      </div>
      <div className="landing-list-card-content">
        <h3 className="landing-list-card-title">{list.title}</h3>
        <p className="landing-list-card-subtitle">
          {list.location} <span className="landing-list-dot">•</span> {list.category}
        </p>
        <div className="landing-list-card-divider" />
        <p className="landing-list-card-meta">
          {list.placeCount} places <span className="landing-list-dot">•</span> {list.visitedPercent}% visited <span className="landing-list-dot">•</span> {list.followers} followers
        </p>
      </div>
    </div>
  );
}

function PlacePreviewCard({ place }) {
  const statusLabels = {
    'visited': 'Visited',
    'want-to-go': 'Want to Go',
    'highly-recommended': 'Highly Recommended',
    'gem': 'Gem'
  };

  const getOpenStatus = () => {
    if (place.isOpen === null) return null;
    return place.isOpen ? (
      <span className="landing-place-open">Open</span>
    ) : (
      <span className="landing-place-closed">Closed</span>
    );
  };

  return (
    <div className="landing-place-card">
      <div className="landing-place-card-image">
        <img src={place.imageUrl} alt={place.name} />
        <span className={`landing-place-status landing-place-status-${place.status}`}>
          {statusLabels[place.status]}
        </span>
      </div>
      <div className="landing-place-card-content">
        <h4 className="landing-place-card-name">{place.name}</h4>
        <p className="landing-place-card-category">{place.category}</p>
        <div className="landing-place-card-info">
          {getOpenStatus()}
          {place.friendsSaved > 0 && (
            <span className="landing-place-friends">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
              {place.friendsSaved} friends saved
            </span>
          )}
        </div>
        <p className="landing-place-card-address">{place.address}</p>
      </div>
    </div>
  );
}

function FeatureCard({ feature }) {
  return (
    <div className="landing-feature-card">
      <div className="landing-feature-icon">{feature.icon}</div>
      <h3 className="landing-feature-title">{feature.title}</h3>
      <p className="landing-feature-description">{feature.description}</p>
    </div>
  );
}

function Landing() {
  const navigate = useNavigate();

  return (
    <div className="landing-container">
      {/* Hero Section */}
      <section className="landing-hero">
        <div className="landing-hero-content">
          <img src="/logo.png" alt="Vibary Logo" className="landing-logo" />
          <h1 className="landing-title">Vibary</h1>
          <p className="landing-subtitle">Your personal library of vibes</p>
          <p className="landing-tagline">
            Discover and share vetted place recommendations with people you trust
          </p>
          <div className="landing-hero-buttons">
            <button
              className="landing-btn-primary"
              onClick={() => navigate('/login')}
            >
              Get Started
            </button>
            <button
              className="landing-btn-secondary"
              onClick={() => document.getElementById('features').scrollIntoView({ behavior: 'smooth' })}
            >
              Learn More
            </button>
          </div>
        </div>
        <div className="landing-hero-visual">
          <div className="landing-phone-mockup">
            <div className="landing-phone-screen">
              <div className="landing-phone-header">
                <img src="/logo.png" alt="Profile" className="landing-phone-avatar" />
                <span className="landing-phone-title">My Lists</span>
                <div className="landing-phone-add-btn">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                </div>
              </div>
              <div className="landing-phone-content">
                {PHONE_LISTS.map(list => (
                  <div key={list.id} className="landing-phone-card">
                    <div className="landing-phone-card-hero">
                      <img src={list.imageUrl} alt={list.title} />
                    </div>
                    <div className="landing-phone-card-content">
                      <span className="landing-phone-card-title">{list.title}</span>
                      <span className="landing-phone-card-meta">{list.location} • {list.category}</span>
                      <span className="landing-phone-card-stats">{list.placeCount} places</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="landing-features-section">
        <div className="landing-section-header">
          <h2>Everything you need to discover great places</h2>
          <p>Curate, share, and explore with confidence</p>
        </div>
        <div className="landing-features-grid">
          {FEATURES.map((feature, index) => (
            <FeatureCard key={index} feature={feature} />
          ))}
        </div>
      </section>

      {/* Discover Lists Section */}
      <section className="landing-discover-section">
        <div className="landing-section-header">
          <h2>Discover curated lists</h2>
          <p>Explore recommendations from trusted creators</p>
        </div>
        <div className="landing-lists-scroll">
          {DISCOVER_LISTS.map(list => (
            <ListPreviewCard key={list.id} list={list} />
          ))}
        </div>
      </section>

      {/* Place Details Section */}
      <section className="landing-places-section">
        <div className="landing-section-header">
          <h2>Track your favorites</h2>
          <p>Mark places as visited, want-to-go, highly recommended, or gems</p>
        </div>
        <div className="landing-places-grid">
          {SAMPLE_PLACES.map(place => (
            <PlacePreviewCard key={place.id} place={place} />
          ))}
        </div>
      </section>

      {/* Map Preview Section */}
      <section className="landing-map-section">
        <div className="landing-map-content">
          <div className="landing-map-text">
            <h2>See it all on the map</h2>
            <p>
              Visualize all your saved places on an interactive map.
              Perfect for planning your next trip or finding
              spots near you.
            </p>
            <ul className="landing-map-features">
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                Color-coded pins by list
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                Filter by category or status
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                See opening hours at a glance
              </li>
            </ul>
          </div>
          <div className="landing-map-visual">
            <div className="landing-map-placeholder">
              {/* Street grid pattern */}
              <div className="landing-map-streets">
                <div className="landing-map-street landing-map-street-h1" />
                <div className="landing-map-street landing-map-street-h2" />
                <div className="landing-map-street landing-map-street-h3" />
                <div className="landing-map-street landing-map-street-v1" />
                <div className="landing-map-street landing-map-street-v2" />
                <div className="landing-map-street landing-map-street-v3" />
                <div className="landing-map-street landing-map-street-v4" />
                <div className="landing-map-street landing-map-street-diagonal" />
              </div>
              {/* Map pins */}
              <div className="landing-map-pin landing-map-pin-1">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="var(--primary)" aria-hidden="true">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" fill="white" />
                </svg>
              </div>
              <div className="landing-map-pin landing-map-pin-2">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="var(--gold)" aria-hidden="true">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" fill="white" />
                </svg>
              </div>
              <div className="landing-map-pin landing-map-pin-3">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="var(--gem)" aria-hidden="true">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" fill="white" />
                </svg>
              </div>
              <div className="landing-map-pin landing-map-pin-4">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="var(--info)" aria-hidden="true">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" fill="white" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Creator Section */}
      <section className="landing-creator-section">
        <div className="landing-creator-content">
          <div className="landing-creator-text">
            <h2>Are you a creator?</h2>
            <p>
              Partner with Vibary and earn money sharing your favorite spots with your audience.
              Turn your recommendations into something your followers can save, explore, and return to.
            </p>
            <ul className="landing-creator-perks">
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                Base payment + performance bonuses
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                Your followers get Premium free for 2 weeks
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                You get Vibary Premium for life and featured placement in app
              </li>
            </ul>
          </div>
          <button
            className="landing-btn-secondary landing-creator-btn"
            onClick={() => navigate('/creator')}
          >
            Learn About Our Creator Program
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </button>
        </div>
      </section>

      {/* CTA Section */}
      <section className="landing-cta-section">
        <div className="landing-cta-content">
          <h2>Start building your library of vibes</h2>
          <p>Join others discovering and sharing their favorite places</p>
          <button
            className="landing-btn-primary landing-btn-large"
            onClick={() => navigate('/login')}
          >
            Get Started Free
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="landing-footer-content">
          <div className="landing-footer-brand">
            <img src="/logo.png" alt="Vibary" className="landing-footer-logo" />
            <span>Vibary</span>
          </div>
          <div className="landing-footer-links">
            <a href="/legal/privacy">Privacy Policy</a>
            <a href="/legal/terms">Terms of Service</a>
            <a href="/legal/cookies">Cookie Policy</a>
          </div>
          <p className="landing-footer-copyright">
            © {new Date().getFullYear()} Vibary. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Landing;
